import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { hash } from 'rsvp'
import type { SchoolScope, StudentsScope } from 'teacher-ui-client/reporting/ui-scope/utils'
import type { NormalizedInterval } from 'date-fns'
import type ReportingUiScopeRoute from 'teacher-ui-client/reporting/ui-scope/route'
import type StudentEventsService from 'teacher-ui-client/services/student-events'

export default class FastPhonicsReportingProgressReviewRoute extends Route {
  @service studentEvents!: StudentEventsService

  async model() {
    const { uiScope, scopedData, period } = this.modelFor('reporting.ui-scope') as ModelFor<ReportingUiScopeRoute>

    const scopedStudents = scopedData.students
    const statsScope: StudentsScope = { scope: 'students', ids: scopedStudents.map((s) => s.id) }

    const product: LegacyProductFp = 'fast_phonics'
    const stats = await this.makeStatsRequests(product, statsScope, period)

    return { stats, scopedStudents, uiScope }
  }

  makeStatsRequests = async (
    product: LegacyProductFp,
    scope: SchoolScope | StudentsScope,
    period: NormalizedInterval,
  ) => {
    return hash({
      peaksProgress: this.studentEvents.peaksProgress(product, scope, period),
    })
  }
}
